import React from 'react';
import { useDispatch } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import { Modal, Button } from 'semantic-ui-react';
import arrayMutators from 'final-form-arrays';
import { FERTILIZER_EVENT_UPDATE_MODAL } from 'scenes/Fertilizer/constants';
import { updateQueryString } from 'services/router/actions';
import FertilizerEventSummaryPage from '../FertilizerEventSummaryPage';

interface Props {
    initialValues: Record<string, any>;
}

export default function FertilizerEventReadOnlySummaryPage(
    props: Props
): React.ReactElement {
    const { initialValues } = props;

    const dispatch = useDispatch();

    return (
        <React.Fragment>
            <Modal.Header>Completed Fertilizer Event</Modal.Header>
            <Modal.Content>
                <section className="spray-event-modal || constrain-width">
                    <FinalForm
                        initialValues={initialValues}
                        onSubmit={(): void => {}}
                        mutators={{ ...arrayMutators }}
                    >
                        {(): React.ReactElement => (
                            <FertilizerEventSummaryPage readOnly />
                        )}
                    </FinalForm>
                    <div className="footer-buttons || buttons">
                        <Button
                            type="button"
                            onClick={(): void => {
                                dispatch(
                                    updateQueryString({
                                        [FERTILIZER_EVENT_UPDATE_MODAL]:
                                            undefined,
                                        fertilizerEventUuid: undefined
                                    })
                                );
                            }}
                            basic
                            primary
                        >
                            Close
                        </Button>
                    </div>
                </section>
            </Modal.Content>
        </React.Fragment>
    );
}
